import {
  TrendingUp,
  Users,
  DollarSign,
  Calendar,
  Star,
  ExternalLink,
} from "lucide-react";

export const ExtensionCard = ({ extension }) => {
  return (
    <div className="bg-panel rounded-xl shadow-lg shadow-black/20 hover:shadow-xl transition-all duration-300 overflow-hidden border border-line hover:border-zinc-700 flex flex-col h-full">
      <div className="p-6 flex flex-col flex-grow">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#4d94ff] via-primary to-[#0a4fb0] flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
              {extension.name.charAt(0)}
            </div>
            <div className="min-w-0">
              <h3 className="text-xl font-bold text-white">
                {extension.name}
              </h3>
              <p className="text-sm text-zinc-400">{extension.category}</p>
            </div>
          </div>
          <div className="flex items-center gap-1 bg-yellow-500/10 px-2 py-1 rounded-lg flex-shrink-0">
            <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
            <span className="text-sm font-semibold text-zinc-300">
              {extension.rating}
            </span>
          </div>
        </div>

        <p className="text-zinc-400 mb-4 text-sm leading-relaxed h-20">
          {extension.description}
        </p>

        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="bg-green-500/10 rounded-lg p-3 border border-green-500/20 h-24 flex flex-col">
            <div className="flex items-center gap-2 mb-1">
              <DollarSign className="w-4 h-4 text-green-500" />
              <span className="text-xs font-medium text-zinc-400">Revenue</span>
            </div>
            <p className="text-lg font-bold text-green-400 mb-auto">
              {extension.revenue}
            </p>
            <p className="text-xs text-zinc-400">{extension.revenueModel}</p>
          </div>

          <div className="bg-primary/10 rounded-lg p-3 border border-primary/20 h-24 flex flex-col">
            <div className="flex items-center gap-2 mb-1">
              <Users className="w-4 h-4 text-primary" />
              <span className="text-xs font-medium text-zinc-400">Users</span>
            </div>
            <p className="text-lg font-bold text-[#4d94ff] mb-auto">
              {extension.users}
            </p>
            <p className="text-xs text-zinc-400">Active installs</p>
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-line mt-auto">
          <div className="flex items-center gap-2 text-sm text-zinc-400">
            <Calendar className="w-4 h-4" />
            <span>{extension.age}</span>
          </div>
          <div className="flex items-center gap-2 text-sm font-semibold text-[#b794ff]">
            <TrendingUp className="w-4 h-4" />
            <span>{extension.growth}</span>
          </div>
        </div>

        {!extension.link && (
          <a
            href={extension.link}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 w-full bg-gradient-to-r from-[#4d94ff] via-primary to-[#0a4fb0] text-white py-2 px-4 rounded-lg font-medium hover:from-[#3d84ef] hover:to-[#094090] transition-all flex items-center justify-center gap-2"
          >
            View Extension
            <ExternalLink className="w-4 h-4" />
          </a>
        )}
      </div>
    </div>
  );
};
